import { render } from "./labsNavbar.vue?vue&type=template&id=fc369ad6&scoped=true"
import script from "./labsNavbar.vue?vue&type=script&lang=js"
export * from "./labsNavbar.vue?vue&type=script&lang=js"

import "./labsNavbar.vue?vue&type=style&index=0&id=fc369ad6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc369ad6"]])

export default __exports__